module.exports = __webpack_public_path__ + "static/media/sytem_pc_img.71f94ab8.png";